export const AcaBillingAndPayment = {
  AcademyBillItemType: {
    anotherClassService: 1,
    anotherClassMessage: 10,
    anotherClassContentPoint: 20,
    anotherClassEtc: 98,
    anotherClassMixed: 99,
  },
  AcademyBillItemName: {
    anotherClassService: 'AnotherClass Service',
    anotherClassMessage: 'AnotherClass Message Charge',
    anotherClassContentPoint: 'AnotherClass Content Points',
    anotherClassEtc: 'AnotherClass Etc',
    anotherClassMixed: 'AnotherClass Mixed',
  },
};
